import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { updateEmpProfileAlbumsApi } from "../../API/API";

function* updateEmpAlbumsSaga(params) {
  try {
    const response = yield call(updateEmpProfileAlbumsApi, params);
    yield put({
      type: types.UPDATE_EMP_ALBUMS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.UPDATE_EMP_ALBUMS_FAILURE, error });
  }
}

export function* watchUpdateEmpAlbumsSaga() {
  yield takeEvery(types.UPDATE_EMP_ALBUMS_REQUESTED, updateEmpAlbumsSaga);
}
